<script>
  import BadgeState from "../../../Stores/badgeState"
  import Button from "../../../Shared/Button.svelte"
  import { onMount } from "svelte"
  import { RIBBONS_SVG } from "../../../../../../Script/ribbons"
  import RibbonSvgComponent from "./Components/ribbonSvgComponent.svelte"
  export let bgRibbon = false
  export let operationId = ""
  let ribbonID = ""
  const SCALING_FACTOR = 0.4

  onMount(async () => {
    ribbonID = operationId.split("#")[0]
  })

  // const extractPathData = (id) => {
  //   try {

  //     let element = document.querySelector(`#${id}`)
  //     width = element.viewBox.baseVal.width
  //     height = element.viewBox.baseVal.height

  //     let childNodes = element.childNodes

  //     let pathArr = []
  //     for (let i = 0; i < childNodes.length; i++) {
  //       let pathAttrObj = {}

  //       pathAttrObj.d = childNodes[i].getAttribute("d")
  //       pathAttrObj.id = childNodes[i].getAttribute("id")
  //       pathAttrObj.fill = childNodes[i].getAttribute("fill")

  //       pathArr.push(pathAttrObj)
  //     }

  //     return pathArr
  //   } catch (error) {
  //     console.error(error)

  //     throw error
  //   }
  // }
  const addRibbon = () => {
    let ribbon = RIBBONS_SVG.find((ribbon) => ribbon.id == ribbonID)
    if (!ribbon) return

    // Create a deep copy to avoid reference issues
    let pathData = ribbon.data.map((path) => ({
      ...path, // Spread operator to copy object properties
      id: `${ribbonID}-${Date.now()}-${Math.random() * 100000}`,
    }))

    let element = document.querySelector(`#${ribbonID}`)
    let width = element.viewBox.baseVal.width
    let height = element.viewBox.baseVal.height

    if (operationId) {
      $BadgeState.operations = $BadgeState.operations.map((operation) => {
        if (operation.id == operationId) {
          return {
            ...operation,
            data: pathData, // Assign new copy
            id: `${ribbonID}|${Date.now()}|${width}|${height}`,
            width: width * SCALING_FACTOR,
            height: height * SCALING_FACTOR,
          }
        }
        return operation
      })
    } else {
      let ribbonLayer = {
        id: `${ribbonID}|${Date.now()}|${width}|${height}`,
        active: true,
        value: `Ribbon ${$BadgeState.operations.length + 1}`,
        type: "ribbon",
        data: pathData, // Assign new copy
        x: Math.floor($BadgeState.baseInfo.width / 2),
        y: Math.floor($BadgeState.baseInfo.height / 2),
        width: width * SCALING_FACTOR,
        height: height * SCALING_FACTOR,
        rotation: 0,
      }

      // active false applied before layer
      $BadgeState.operations.forEach((operation) => {
        operation.active = false
      })

      $BadgeState.operations = [ribbonLayer, ...$BadgeState.operations]
    }
    $BadgeState.footer = "RIBBON"
    ribbonID = "" // Reset ribbonID after adding
    bgRibbon = false
  }
</script>

<div class="fixed inset-0 z-30 flex flex-col items-center justify-center overflow-y-auto bg-[#000000cc] text-left backdrop-blur-md transition-opacity">
  <div>
    <div class="w-[500px] rounded-t-md bg-darkgray p-6">
      <h1 class="text-lg font-bold tracking-wide text-slate-100">Choose Ribbons</h1>

      <div class="mt-3 flex h-full gap-3">
        <div class="grid h-72 w-full grid-cols-3 gap-3 overflow-y-auto rounded-md border border-stone-700 bg-[#242424] p-3">
          {#each RIBBONS_SVG as svgElem}
            <div class="flex items-center justify-center gap-3">
              <RibbonSvgComponent bind:active={ribbonID} ribbon={svgElem} />
            </div>
          {/each}
        </div>
      </div>

      <!-- color palatte showing place -->

      {#each RIBBONS_SVG.filter((ribbon) => ribbon.id == ribbonID) as ribbon}
        <h1 class="mt-3 text-lg font-bold tracking-wide text-slate-100">Choose Color Palette</h1>
        <p class="py-2 text-sm font-normal leading-relaxed text-gray-600">The colors can be customized later as well.</p>
        <div class="mt-3 flex flex-wrap gap-3">
          {#each ribbon.palette as palette, index}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              on:click={() => {
                ribbon.selectedpalate = index
                for (let i = 0; i < ribbon.data.length; i++) {
                  ribbon.data[i].fill = palette[i]
                }
              }}
              class="flex cursor-pointer items-center gap-1 rounded-lg border-2 p-2 transition duration-200 hover:shadow-md
              {ribbon.selectedpalate === index ? 'border-blue-500 shadow-lg' : 'border-gray-800'}"
            >
              {#each palette as color}
                <div class="h-6 w-6 rounded" style="background: {color};" />
              {/each}
            </div>
          {/each}
        </div>
      {/each}
    </div>

    <div class="flex justify-between rounded-b-md bg-[#242424] px-5 py-3">
      <Button on:click text="Close" addClass="bg-red-500" iconClass="fa-circle-xmark" />
      <Button
        state={!ribbonID}
        on:click={() => {
          addRibbon()
        }}
        text="Confirm"
        addClass="bg-green-500"
        iconClass="fa-circle-check"
      />
    </div>
  </div>
</div>
